import {Marked} from 'marked';
import {markedSmartypants} from 'marked-smartypants';
import {markedHighlight} from 'marked-highlight';
import {loadDynamicStylesheet} from './loadDynamicDependency.js'

const marked = new Marked(
  markedHighlight({
    async: true,
    highlight(code, lang) {
      return new Promise(async (resolve) => {
        lang = lang.replace(new RegExp('-wrap$'), '');

        if (lang && !window.Prism.languages[lang] && window.Prism.plugins.autoloader) {
          try {
            await new Promise((langResolve, langReject) => {
              window.Prism.plugins.autoloader.loadLanguages(lang, langResolve, langReject);
            });
          } catch (error) {
            // Could not load language
          }
        }

        if (lang && window.Prism.languages[lang]) {
          resolve(window.Prism.highlight(code, window.Prism.languages[lang], lang));
        }
        resolve(code);
      });
    }
  })
);
marked.use(markedSmartypants());

window.Prism.plugins.autoloader.languages_path = '/javascripts/prism/';

export async function renderKeliMarkdown(markdownText, toElement, options) {
  markdownText = `${markdownText}`;

  let html = await marked.parse(markdownText, {
    gfm: true,
    breaks: true,
    smartLists: true
  });

  // Replace <a> with <keli-a>
  html = html.replace(/<a(\b[^>]*)>(.*?)<\/a>/ig, '<keli-a$1>$2</keli-a>');

  // Replace :icon:*: with <sl-icon>
  html = html.replace(/:icon:([a-z\d_\-]+):/ig, '<sl-icon name="$1"></sl-icon>');

  if (options && options.preventSolitaryParagraph) {
    const matches = html.trim().match(/^<p>(.*)<\/p>$/);
    if (matches && matches[1] && !matches[1].includes('<p>')) {
      html = matches[1];
    }
  }

  if (typeof window.filterXSS !== 'undefined') {
    html = window.filterXSS(html, {
      whiteList: window.filterXSSWhiteList,
      css: false,
      onIgnoreTag(tag, html) {
        if (tag.startsWith('keli-') || tag.startsWith('sl-')) {
          return html;
        }
      },
      onIgnoreTagAttr(tag, name, value) {
        if (['class', 'style'].includes(name)) {
          return `${name}="${window.filterXSS.escapeAttrValue(value)}"`;
        }
      }
    });
  }

  if (toElement) {
    if (html.includes('class="language-')) {
      const stylesheet = (KeliInterface.Styles.palette.darkMode ? 'prism-dark' : 'prism-light');
      await loadDynamicStylesheet(`/styles/${stylesheet}.css`, 'prism', toElement.getRootNode());
    }

    toElement.innerHTML = html;
    window.emojify.run(toElement);
  } else {
    return html;
  }
}